/**
 *
 * Currently we either have 0, 1, or 2 charting notes.
 * This creates height offset for note editor to make space
 * for the note(s).
 */
export const getChartingNoteHeightOffset = (
  chartingNotesLength: number,
): string => {
  const heightOffsetForEachNote = 40;

  return `${heightOffsetForEachNote * chartingNotesLength}px`;
};

export const formatCurrency = (val: string | number) => {
  if (!val) return 'N/A';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(+val);
};

export const formatCurrencyWithoutRound = (amount: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
